import { ExamplePageId } from 'components/projects/pages/examples/examplePages';
import { PageTemplateObject } from 'data/v3/data-contracts';

type ExamplePageObject = {
  id: ExamplePageId;
  title: string;
  isExample: boolean;
};

export type AllPageTemplates = PageTemplateObject | ExamplePageObject;

export const sortPageTemplatesAlphabetically = ({
  pageTemplates,
  defaultTitleComparator,
}: {
  pageTemplates: AllPageTemplates[];
  defaultTitleComparator: string;
}) => {
  return pageTemplates.sort((a, b) => {
    const titleA = a.title || defaultTitleComparator;
    const titleB = b.title || defaultTitleComparator;
    return titleA.localeCompare(titleB);
  });
};

export const getRecentlyUsedPagesTemplates = (
  pageTemplates: PageTemplateObject[],
) =>
  pageTemplates
    .filter((template) => template.lastUsedAt)
    .sort((a, b) => {
      return (
        new Date(b.lastUsedAt).getTime() - new Date(a.lastUsedAt).getTime()
      );
    })
    .slice(0, 3);
